angular.module('env.log.logDecorator', [])

    .config(function ($provide) {

        $provide.decorator('$log', function ($delegate, omLogger) {

            $delegate = _.extend($delegate, {
                assert: omLogger.assert,
                count: omLogger.count,
                dir: omLogger.dir,
                group: omLogger.group,
                groupCollapsed: omLogger.groupCollapsed,
                groupEnd: omLogger.groupEnd,
                time: omLogger.time,
                timeEnd: omLogger.timeEnd,
                debug: omLogger.debug,
                trace: omLogger.trace,
                log: omLogger.log,
                info: omLogger.info,
                warn: omLogger.warn,
                error: omLogger.error,
                fatal: omLogger.fatal
            });

            return $delegate;
        });
    })

;
